import { render, staticRenderFns } from "./SyncProduct.vue?vue&type=template&id=6de3a217&scoped=true"
import script from "./SyncProduct.vue?vue&type=script&lang=js"
export * from "./SyncProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de3a217",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de3a217')) {
      api.createRecord('6de3a217', component.options)
    } else {
      api.reload('6de3a217', component.options)
    }
    module.hot.accept("./SyncProduct.vue?vue&type=template&id=6de3a217&scoped=true", function () {
      api.rerender('6de3a217', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/lists/SyncProduct.vue"
export default component.exports